import type { AssignedWorkoutTree } from "./assignedWorkoutTree";
import { rowsFromSets, type WorkoutDraft } from "./builder";

/**
 * W95 — THE BUILDER'S DRAFT IN THE TREE'S SHAPE, for the phone preview (his word, 2026-09-29: the workout saves only on
 * Save). Until then the saved row is older than the screen — and a new workout has none — so the preview draws what the
 * coach is looking at, through the phone's own reader (`workoutOverview`), never a second drawing. The sets go through
 * `rowsFromSets`, the save's own mapping, so the preview and the save cannot word a set differently. Ids are positional
 * (`draft-s0`, `draft-s0-e1`, …): the reader keys on them and nothing here is written anywhere.
 */
export function draftTree(draft: WorkoutDraft): AssignedWorkoutTree {
  return {
    id: draft.id ?? "draft",
    name: draft.name,
    description: draft.description,
    coach_workout_sections: draft.sections.map((sec, si) => ({
      id: `draft-s${String(si)}`,
      position: si,
      name: sec.name,
      format: sec.format,
      section_type: sec.sectionType,
      format_config: Object.keys(sec.formatConfig).length > 0 ? sec.formatConfig : null,
      description: sec.description,
      is_implicit: sec.isImplicit,
      coach_workout_exercises: sec.exercises.map((ex, ei) => ({
        id: `draft-s${String(si)}-e${String(ei)}`,
        exercise_id: ex.libraryExerciseId,
        position: ei,
        each_side: ex.eachSide,
        hold_until_lost: ex.holdUntilLost === true,
        tempo: ex.tempo,
        notes: ex.note,
        superset_with_next: ex.supersetWithNext,
        coach_exercises: { name: ex.name },
        coach_workout_sets: rowsFromSets(ex.sets).map((r) => ({
          id: `draft-s${String(si)}-e${String(ei)}-t${String(r.position)}`,
          position: r.position, reps: r.reps, weight_kg: r.weight_kg, time_seconds: r.time_seconds,
          rounds: r.rounds, rest_seconds: r.rest_seconds, set_type: r.set_type,
          // W136 B2 S3r6 P5 — a run's metres ride the preview too (MEASURED: without it the walk's M / KM column drew empty).
          distance_m: r.distance_m,
        })),
      })),
    })),
  };
}
